import React from 'react';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';

import ForgotPasswordForm from './ForgotPasswordForm';

import Logo from '../../assets/images/puntu-logo2.svg';

const styles = theme => ({
  container: {
    minHeight: '100vh',
    height: 'auto',
    padding: theme.spacing(4),
  },
  logo: {
    width: '40px',
  },
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
    border: '1px solid',
    borderColor: theme.palette.grey[300],
    fontSize: '0.75rem',
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
});

const ForgotPassword = ({
  classes, loading, onResetPassword, location,
}) => (
  <Grid container justify="center" alignItems="flex-start" className={classes.container}>
    <Grid container justify="space-between" alignItems="center">
      <Link to={location.state ? location.state.returnLink : '/login'}>
        <img src={Logo} alt="Puntu" className={classes.logo} />
      </Link>
      <Typography align="right" color="textSecondary">
        <Hidden xsDown>Não possui conta?</Hidden>
        <Button
          component={Link}
          to={location.state ? '/registrar-empregado' : '/cadastro?plan=light&Anual=false'}
          color="inherit"
          className={classes.button}
        >
          Criar conta
        </Button>
      </Typography>
    </Grid>

    <Grid item xs={12} sm={8} md={6} container direction="column">
      <Grid item>
        <Typography variant="h5" color="textSecondary" gutterBottom>
          Esqueceu sua senha?
        </Typography>
        <Typography color="textSecondary" paragraph>
          Digite seu endereço de email abaixo e nós lhe enviaremos um link para redefinir a sua
          senha.
        </Typography>
      </Grid>
      <Grid item>
        <ForgotPasswordForm onResetPassword={onResetPassword} loading={loading} />
      </Grid>
    </Grid>
  </Grid>
);

export default withStyles(styles)(ForgotPassword);
